import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=720146e0&scoped=true&"
import script from "./UserProfileCard.vue?vue&type=script&lang=js&"
export * from "./UserProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720146e0",
  null
  
)

export default component.exports